// extracted by mini-css-extract-plugin
export default {"overlay":"LoaderLogin_overlay__LVa8d","loader":"LoaderLogin_loader__IsFg5","bounce":"LoaderLogin_bounce__QQRr-"};